import { atom } from "recoil";

export const brandLicensesAddModalStore = atom({
	key: "brandLicensesAddModalStore",
	default: {
		show: false,
		loaded: false,
		formData: {
			company: '',
			license_name: '',
			license_number: '',
			license_country: '',
			license_address: '',
			license_url: '',
			license: '',
			image_path: '',
			domain: '',
			ltd: '',
			translate: '',
		},
		jsonData: '',
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
